import { useState } from 'react';
import Sidebar from '../components/Sidebar';
import ContentHeader from '../components/ContentHeader';
import { useAuth } from "../contexts/AuthContext";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";


const InfoBox = ({ title, value, icon }) => {
  return (
    <div className="column mr-4 mr-6 my-6">
      <div className="box columns is-shadowless" style={{border: '1px solid rgba(0,0,0,0.1)'}}>
        <div className="column is-four-fifths p-0">
          <p className="heading is-6">{title}</p>
          <p className="title is-4">{value}</p>
        </div>
        <div className="column is-one-fifth p-0">
          <span className="icon is-large is-pulled-right has-text-white has-background-link" style={{ borderRadius: '5px' }}>
            <i className={`fas ${icon} fa-lg`}></i>
          </span>
        </div>
      </div>
    </div>
  );
};

const DEFAULT_STATS = { num_circuits: 3, execution_time: 24, used_storage: 2.4, jobs: 248 };
const DashboardPage = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(DEFAULT_STATS);

  // Compute hours consumed over the last 7 days
  const computeUsageData = [
    { day: "Oct 28", hours: 8.2 },
    { day: "Oct 29", hours: 12.5 },
    { day: "Oct 30", hours: 6.8 },
    { day: "Oct 31", hours: 15.3 },
    { day: "Nov 1", hours: 9.7 },
    { day: "Nov 2", hours: 11.2 },
    { day: "Nov 3", hours: 14.1 },
  ];

  const quotaLimit = 100; // Monthly quota in hours
  const totalUsed = computeUsageData.reduce((sum, day) => sum + day.hours, 0);

  const getUserStats = async () => {

    setStats(DEFAULT_STATS);
  };
  // getUserStats();
  // useEffect(() => {
  //   getUserStats();
  // }, {});

  return (
    <div className="columns is-unselectable" style={{ height: "100vh", display: 'flex', flexDirection: 'row' }}>
      <Sidebar />
      <div className="column p-6 has-background-light">

        <ContentHeader title="Dashboard" subtitle="Monitor your zk experiments and benchmarks" showBackButton={false} />

        {/* Info Boxes */}
        <div className="columns is-mobile mx-0">
          <InfoBox title="Total Circuits" value={stats.num_circuits} icon="fa-microchip" />
          <InfoBox title="Running Benchmarks" value={stats.jobs}  icon="fa-circle-notch" />
          <InfoBox title="Storage" value={`${stats.used_storage} GB`} icon="fa-hdd" />
          <InfoBox title="Compute Hours" value={`${stats.execution_time} core-min`} icon="fa-clock" />
        </div>

        {/* Graph Placeholder */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-6">
          <div className="bg-gray-100 px-4 py-2 border-b border-gray-200 flex items-center justify-between">
            <span className="text-sm">
              Compute Hours (Last 7 Days)
            </span>
            <span className="text-xs text-gray-500">
              {totalUsed.toFixed(1)}h / {quotaLimit}h used
            </span>
          </div>
          <div className="p-6">
            <ResponsiveContainer width="100%" height={200}>
              <BarChart data={computeUsageData}>
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#e5e7eb"
                  vertical={false}
                />
                <XAxis
                  dataKey="day"
                  stroke="#9ca3af"
                  style={{ fontSize: "12px" }}
                  tickLine={false}
                />
                <YAxis
                  stroke="#9ca3af"
                  style={{ fontSize: "12px" }}
                  tickLine={false}
                  axisLine={false}
                  label={{
                    value: "Hours",
                    angle: -90,
                    position: "insideLeft",
                    style: { fontSize: "11px", fill: "#9ca3af" },
                  }}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "white",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    fontSize: "12px",
                  }}
                  formatter={(value) => [`${value.toFixed(1)}h`, "Compute Hours"]}
                  cursor={{ fill: "rgba(102, 126, 234, 0.05)" }}
                />
                <Bar
                  dataKey="hours"
                  fill="url(#barGradient)"
                  radius={[4, 4, 0, 0]}
                />
                <defs>
                  <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#667eea" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#764ba2" stopOpacity={0.6} />
                  </linearGradient>
                </defs>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
